import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { UseCurrentSPIProvider } from 'components/widgets/CurrentSPI/CurrentSPI.provider';
import { getValueClassName } from 'components/widgets/CurrentSPI/CurrentSPI.utils';

interface Props {
    api: UseCurrentSPIProvider['api'];
    setIsPayloadReady?: (newValue: boolean) => void;
    widgetViewMode?: WidgetViewMode;
}

export const useCurrentSPILogic = ({ api, setIsPayloadReady, widgetViewMode }: Props) => {
    const isPayloadReady = () => {
        const currentPayload = api.getCurrentSPI.payload;
        if (!currentPayload) return;
        if (
            currentPayload.compareVersionId === undefined ||
            currentPayload.latestVersionId === undefined ||
            currentPayload.contractId === undefined ||
            currentPayload.contractId === null
        ) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });
    const value = api.getCurrentSPI.instance.data?.value;
    const threshold = api.getCurrentSPI.instance.data?.threshold;
    const calculatedValue = api.getCurrentSPI.instance.data?.value ? api.getCurrentSPI.instance.data?.value : 'N/A';

    return {
        logic: {
            valueClassName: getValueClassName(value, threshold),
            calculatedValue,
        },
    };
};
